"use strict";
import { didUserReject } from "utils/swapErrorToUserReadableMessage";
const WALLET_REQUEST_TIMEOUT_MS = 45e3;
const MINT_ERROR_MESSAGES = [
  {
    needles: ["PrecisionLoss", "0x63c8f3fb"],
    key: "mint.error.precisionLoss",
    fallback: "This amount cannot be represented safely. Try a larger amount."
  },
  {
    needles: ["UnsupportedStable", "StableNotSupported", "0xebb7b43a"],
    key: "mint.error.unsupportedStable",
    fallback: "This token is not supported for USDR minting."
  },
  {
    needles: ["SlippageExceeded", "0x8199f5f3"],
    key: "mint.error.slippageExceeded",
    fallback: "Mint quote changed before submission. Please try again."
  },
  {
    needles: ["TokenTransferMismatch", "0xbf96dce5"],
    key: "mint.error.tokenTransferMismatch",
    fallback: "Token transfer amount did not match the mint quote."
  },
  {
    needles: ["TransferHelper::safeTransfer: transfer failed"],
    key: "mint.error.usdrReserveLow",
    fallback: "USDR reserve is too low for this mint amount. Fund fwUSDR or try a smaller amount."
  },
  {
    needles: ["WrappedAmountMismatch", "0x0fdd2757"],
    key: "mint.error.wrappedAmountMismatch",
    fallback: "The configured mint contract is incompatible with this FewToken. Please use the latest minter."
  }
];
function translateOrFallback(translate, key, fallback, options) {
  return translate ? translate(key, { defaultValue: fallback, ...options }) : fallback;
}
export async function withWalletRequestTimeout(request, timeoutMs = WALLET_REQUEST_TIMEOUT_MS) {
  let timeoutId;
  const timeout = new Promise((resolve) => {
    timeoutId = setTimeout(() => resolve(null), timeoutMs);
  });
  try {
    return await Promise.race([request, timeout]);
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
}
export function formatMintError(error, translate) {
  const message = collectErrorText(error);
  const lowerMessage = message.toLowerCase();
  if (didUserReject(error) || lowerMessage.includes("user rejected") || lowerMessage.includes("rejected the request")) {
    return void 0;
  }
  const matchedError = MINT_ERROR_MESSAGES.find(({ needles }) => needles.some((needle) => message.includes(needle)));
  if (matchedError) {
    return translateOrFallback(translate, matchedError.key, matchedError.fallback);
  }
  return translateOrFallback(
    translate,
    "mint.error.transactionFailed",
    "Mint transaction failed. Please review the amount and try again."
  );
}
function collectErrorText(error, seen = /* @__PURE__ */ new Set()) {
  if (error == null) {
    return "";
  }
  if (typeof error === "string" || typeof error === "number" || typeof error === "boolean") {
    return String(error);
  }
  if (typeof error !== "object") {
    return "";
  }
  if (seen.has(error)) {
    return "";
  }
  seen.add(error);
  const record = error;
  const parts = [];
  for (const key of ["shortMessage", "message", "reason", "code", "data"]) {
    const value = record[key];
    if (typeof value === "string" || typeof value === "number") {
      parts.push(String(value));
    } else if (value && typeof value === "object") {
      parts.push(collectErrorText(value, seen));
    }
  }
  for (const key of ["error", "cause", "info"]) {
    parts.push(collectErrorText(record[key], seen));
  }
  return parts.filter(Boolean).join(" ");
}
